const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

document.querySelectorAll('[data-matter-home-hero]').forEach((hero) => {
  const slides = [...hero.querySelectorAll('[data-matter-hero-slide]')];
  const status = hero.querySelector('[data-matter-hero-status]');
  let active = 0;
  let timer;
  let userStopped = false;
  let touchStart = 0;

  const show = (next) => {
    active = (next + slides.length) % slides.length;
    slides.forEach((slide, index) => { slide.hidden = index !== active; });
    if (status) status.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
  };

  const stop = () => window.clearInterval(timer);
  const start = () => {
    stop();
    if (!motion.matches && !userStopped) timer = window.setInterval(() => show(active + 1), 8000);
  };
  const choose = (next) => { userStopped = true; stop(); show(next); };

  hero.querySelector('[data-matter-hero-previous]')?.addEventListener('click', () => choose(active - 1));
  hero.querySelector('[data-matter-hero-next]')?.addEventListener('click', () => choose(active + 1));
  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);
  hero.addEventListener('focusin', stop);
  hero.addEventListener('focusout', (event) => { if (!hero.contains(event.relatedTarget)) start(); });
  hero.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
  hero.addEventListener('touchend', (event) => {
    const distance = event.changedTouches[0].clientX - touchStart;
    if (Math.abs(distance) > 48) choose(active + (distance < 0 ? 1 : -1));
  }, { passive: true });
  motion.addEventListener('change', start);
  show(0);
  start();
});
